export default "__VITE_ASSET__B6uCHrw0__"